import { mapState } from 'vuex'

export default {
	computed: {
		...mapState({
			isApp: (state) => state.app.isApp,
		}),
	},
	mounted() {
		if (this.isApp?.detected) {
			this.$router.replace('/')
		}
	},
}